import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { Label } from '@bluebeam/react-skyline-label';
import { useRef } from 'react';
import { mergeProps, useFocusRing, useRadio, VisuallyHidden } from 'react-aria';
import { useRadioContext } from './RadioContext';
import RadioOptionSvg from './RadioOptionSvg';
const RadioOption = ({ ariaLabel, children, disabled = false, size = '18px', value, ...rest }) => {
    const ref = useRef(null);
    const state = useRadioContext();
    const dataAttributes = useDataAttributes(rest);
    const { isDisabled, inputProps } = useRadio({
        'aria-label': ariaLabel,
        children,
        isDisabled: disabled,
        value,
    }, state, ref);
    const { isFocusVisible, focusProps } = useFocusRing();
    return (_jsxs(Label, { className: buildClassName('group flex items-center', {
            'cursor-pointer': !isDisabled,
        }), ...dataAttributes, children: [_jsx(VisuallyHidden, { children: _jsx("input", { disabled: isDisabled, ...mergeProps(inputProps, focusProps), ref: ref }) }), _jsx(RadioOptionSvg, { isDisabled: isDisabled, isSelected: inputProps.checked, isFocused: isFocusVisible, size: size }), _jsx("span", { className: buildClassName('skyline-text-body-1 my-0 ml-2 mr-0', isDisabled ? 'text-light-gray' : 'text-black'), children: children })] }));
};
export default RadioOption;
//# sourceMappingURL=RadioOption.js.map